import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { Dependant } from "./types";

interface DependentsModalProps {
    open: boolean;
    onClose: () => void;
    dependents: Dependant[];
    selectedDependents: Dependant[];
    onConfirm: (selected: Dependant[]) => void;
}

export const DependentsModal: React.FC<DependentsModalProps> = ({
    open,
    onClose,
    dependents,
    selectedDependents,
    onConfirm,
}) => {
    const [localSelected, setLocalSelected] = useState<Dependant[]>([]);

    useEffect(() => {
        setLocalSelected(selectedDependents || []);
    }, [selectedDependents, open]);

    const handleToggle = (dependent: Dependant) => {
        const targetKey = dependent.FamsaObjps || dependent.ObjectID || dependent.Name || dependent.FullName;
        const exists = localSelected.some(
            (item) => (item.FamsaObjps || item.ObjectID || item.Name || item.FullName) === targetKey
        );

        if (exists) {
            setLocalSelected(
                localSelected.filter(
                    (item) => (item.FamsaObjps || item.ObjectID || item.Name || item.FullName) !== targetKey
                )
            );
        } else {
            setLocalSelected([...localSelected, { ...dependent, DependentSelected: true }]);
        }
    };

    const handleSave = () => {
        onConfirm(localSelected);
        onClose();
    };

    return (
        <Modal
            title={<span className="fw-bold text-dark fs-16"><i className="ti ti-users me-2 text-primary"></i>Select Dependents</span>}
            open={open}
            onCancel={onClose}
            onOk={handleSave}
            okText="Confirm Selection"
            cancelText="Cancel"
            width={650}
            centered
        >
            <div className="py-2" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                {dependents && dependents.length > 0 ? (
                    <div className="d-flex flex-column gap-2">
                        {dependents.map((dependent, idx) => {
                            const targetKey = dependent.FamsaObjps || dependent.ObjectID || dependent.Name || dependent.FullName;
                            const isChecked = localSelected.some(
                                (item) => (item.FamsaObjps || item.ObjectID || item.Name || item.FullName) === targetKey
                            );

                            return (
                                <div
                                    key={idx}
                                    className={`card border cursor-pointer transition-all ${
                                        isChecked ? "border-success bg-success bg-opacity-10 shadow-xs" : "border-light bg-light"
                                    }`}
                                    onClick={() => handleToggle(dependent)}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className="card-body p-3 d-flex align-items-center justify-content-between">
                                        <div>
                                            <h6 className="mb-1 fw-bold text-uppercase text-dark">
                                                {dependent.FullName || `${dependent.FirstName || ''} ${dependent.LastName || ''}`.trim()}
                                            </h6>
                                            <div className="d-flex align-items-center gap-2 flex-wrap text-muted small">
                                                <span className="badge bg-secondary">{dependent.Name || dependent.FamilyMemberText}</span>
                                                {dependent.AgeYears && <span>Age: {dependent.AgeYears}Y</span>}
                                                {dependent.BirthDate && <span>DOB: {dependent.BirthDate}</span>}
                                                {dependent.Gender && (
                                                    <span>Gender: {dependent.Gender === "M" ? "Male" : dependent.Gender === "F" ? "Female" : dependent.Gender}</span>
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <div className={`form-check-input rounded-circle d-flex align-items-center justify-content-center ${isChecked ? 'bg-success border-success text-white' : ''}`} style={{ width: 24, height: 24, fontSize: 14 }}>
                                                {isChecked && <i className="ti ti-check"></i>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className="text-center py-4 text-muted">
                        <i className="ti ti-user-x fs-32 d-block mb-2"></i>
                        No dependents available
                    </div>
                )}
            </div>
        </Modal>
    );
};
